import { z } from 'zod';

/**
 * Схемы ответов API.
 * NOTE: обязаны совпадать с services/widget-api/app/domain/schemas.py.
 * Расхождение полей ловится здесь на рантайме, а не молча ломает экран.
 */

export const partnerConfigSchema = z.object({
  slug: z.string(),
  name: z.string(),
  theme: z.record(z.string()).default({}),
  locale: z.string().default('ru'),
});

export const productSchema = z.object({
  id: z.string(),
  product_type: z.string(),
  title: z.string(),
  colors: z.array(z.string()),
  sizes: z.array(z.string()),
  price_rub: z.number().int(),
  spec: z.record(z.string()).default({}),
});

export const printSchema = z.object({
  id: z.string(),
  title: z.string(),
  image_url: z.string(),
  artist: z.string().nullable(),
  collection: z.string().nullable(),
  source_width: z.number().int(),
  source_height: z.number().int(),
});

export const printAreaSchema = z.object({
  side: z.enum(['front', 'back']),
  width_mm: z.number(),
  height_mm: z.number(),
  box: z.object({
    x: z.number(),
    y: z.number(),
    width: z.number(),
    height: z.number(),
  }),
});

export const orderSchema = z.object({
  id: z.string(),
  number: z.number().int(),
  total_rub: z.number().int(),
  status: z.string(),
  created_at: z.string(),
});

export type PartnerConfig = z.infer<typeof partnerConfigSchema>;
export type Product = z.infer<typeof productSchema>;
export type Print = z.infer<typeof printSchema>;
export type PrintArea = z.infer<typeof printAreaSchema>;
export type Order = z.infer<typeof orderSchema>;


export const mockupSchema = z.object({
  image_url: z.string(),
});

export type Mockup = z.infer<typeof mockupSchema>;
